import { render, staticRenderFns } from "./CompanyBranding.vue?vue&type=template&id=49114d4a&scoped=true"
import script from "./CompanyBranding.vue?vue&type=script&lang=js"
export * from "./CompanyBranding.vue?vue&type=script&lang=js"
import style0 from "./CompanyBranding.vue?vue&type=style&index=0&id=49114d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49114d4a",
  null
  
)

export default component.exports